import React from "react"
import { IGameOfList } from "../../../gatsby-graphql"
import { SectionProps } from "../section-loader"
import {
  ContentWrapper,
  SectionWrapper,
  SectionName,
  SliderWrapper,
  SlideWrapper,
  SlideBackground,
  SlideInformation,
  SlideTitle,
  SlideDescription,
  HoverButtons,
  ButtonWrapper,
  SlideGameLabel,
  SlideGameLogo,
} from "./game-list-elements"
import { IBackgroundColor, ILink } from "../../../gatsby-graphql"
import SlickSlider from "react-slick"
import { ButtonType } from "../../ui/button/button-elements"
import { Button } from "../../ui"
import getBackground from "../../helpers/getBackground"

interface FullWidthBannersProps extends SectionProps {
  data: {
    SectionName?: string
    backgroundColor?: IBackgroundColor
    gameOfList?: IGameOfList[]
    scroll: boolean
  }
}

const FullWidthBanners = ({ data, locale }: FullWidthBannersProps) => {

  let setting = {
    infinite: true,
    slidesToShow: 4,
    arrows: true,
    dots: true,
    swipeToSlide: true,
    autoplay: false,
    autoplaySpeed: data.scroll ? 3000 : undefined,
    responsive: [
      {
        breakpoint: 1279,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 992,
        settings: {
          arrows: false,
          dots: false,
          slidesToShow: 2
        }
      },
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          dots: false,
          slidesToShow: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          arrows: false,
          dots: false,
          slidesToShow: 1
        }
      }
    ]
  }

  const getColor = (color: string): string => {
    if(color && color.includes("hex")) {
      return window.JSON.parse(color).hex;
    } else if (color.length >= 5) {
      return color.includes("#") ? `${color}` : `#${color}`;
    }else{
      return "";
    }
  }

  return (
    <SectionWrapper background={data.backgroundColor ? getBackground(data.backgroundColor) : ""}>
      <ContentWrapper>
        <SectionName>{data?.SectionName}</SectionName>
        <SliderWrapper>
          <SlickSlider
            {...setting}
          >
            {data.gameOfList && data?.gameOfList.length > 0 ? data.gameOfList.map((slide: IGameOfList, index) =>
                <SlideWrapper key={index}>
                  {slide?.label ? <SlideGameLabel color={slide?.label?.color ? getColor(slide?.label.color) : "white"}>{slide?.label?.text}</SlideGameLabel> : <></>}
                  <SlideBackground imgUrl={slide?.Asset !== null && slide.Asset?.url ? slide.Asset.url : ""}>
                    <HoverButtons className={"hidden-buttons"}>
                      {slide?.Hover !== null && slide.Hover?.buttons ? slide?.Hover.buttons.map((button: any, index: number) =>
                        <ButtonWrapper key={index}>
                          <Button
                            type={button?.type as ButtonType}
                            link={button?.link as ILink}
                            locale={locale}
                          >{button?.name}</Button>
                        </ButtonWrapper>) : null}
                    </HoverButtons>
                    <SlideGameLogo src={slide?.GameLogo !== null && slide.GameLogo?.url ? slide.GameLogo.url : ""}/>
                  </SlideBackground>
                  <SlideInformation>
                    <SlideTitle>{slide.Name}</SlideTitle>
                    <SlideDescription>{slide.Description}</SlideDescription>
                  </SlideInformation>
                </SlideWrapper>
              )
              : <> </>}
          </SlickSlider>
        </SliderWrapper>
      </ContentWrapper>
    </SectionWrapper>
  )
}

export default FullWidthBanners
